class VoyagerLightbox {
    constructor(options) {
        this.options = Object.assign(
            {
                selector: ".js-voyager-lightbox",
                itemSelector: '.js-voyager-lightbox__item',
                icons: {
                    close: '<svg class="voyager-lightbox__button-close--svg" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path class="voyager-lightbox__button-close--path" d="M9.10216 7.983L15.3197 1.78213C15.4425 1.63904 15.5067 1.45497 15.4994 1.26672C15.4921 1.07847 15.4139 0.899895 15.2803 0.766681C15.1468 0.633468 14.9677 0.555427 14.7789 0.548156C14.5902 0.540885 14.4056 0.604918 14.2622 0.727459L8.04466 6.92833L1.82716 0.719979C1.68593 0.579129 1.49438 0.5 1.29466 0.5C1.09493 0.5 0.903385 0.579129 0.762158 0.719979C0.62093 0.860829 0.541589 1.05186 0.541589 1.25105C0.541589 1.45025 0.62093 1.64128 0.762158 1.78213L6.98716 7.983L0.762158 14.1839C0.683646 14.2509 0.619881 14.3334 0.574864 14.4262C0.529846 14.519 0.504549 14.6201 0.500559 14.7231C0.496569 14.8261 0.513973 14.9289 0.551679 15.0249C0.589385 15.1208 0.646579 15.208 0.71967 15.2809C0.792761 15.3538 0.880171 15.4109 0.976415 15.4485C1.07266 15.4861 1.17566 15.5034 1.27895 15.4994C1.38224 15.4955 1.48359 15.4702 1.57664 15.4253C1.66968 15.3804 1.75242 15.3168 1.81966 15.2385L8.04466 9.03767L14.2622 15.2385C14.4056 15.3611 14.5902 15.4251 14.7789 15.4178C14.9677 15.4106 15.1468 15.3325 15.2803 15.1993C15.4139 15.0661 15.4921 14.8875 15.4994 14.6993C15.5067 14.511 15.4425 14.327 15.3197 14.1839L9.10216 7.983Z" fill="#081632"/></svg>',
                }
            },
            options
        );

        this.setData = [];
        this.getData = [];
        this.isOpen = false;
        this.popupMain;
        this.currentItems;
        this.singleItem;
        this.currentIndex;
        this.selectorDataset;
        this.mainSplide;
        this.story;
    }

    groupElement() {
        var _self = this;
        const { selector } = _self.options;
        var group_element = document.querySelectorAll(selector);
        
        if (group_element.length === 0) {
            _self.options.selector = '.voyager-lightbox'
        }        
        
        document.querySelectorAll(_self.options.selector)?.forEach((element) => {            
            if (element.dataset.lightboxGroup == undefined) {
                console.log('Please Use data-gallery attribute in parent element.');
                return false
            }
            _self.itemElement(element);
        });
    }

    itemElement(element) {
        var _self = this,
            items = [];
        const { itemSelector } = _self.options;
        var item_element = element.querySelectorAll(itemSelector);
        if (item_element.length === 0) {
            _self.options.itemSelector = '.voyager-lightbox__item'
        }        

        element.querySelectorAll(_self.options.itemSelector)?.forEach((element, i) => {
            var caption = element.dataset.lightboxCaption,
                poster = element.dataset.lightboxPoster,
                popup_content = element.dataset.popupContent;

            items.push({ 'link': element.href, 'type': element.dataset.lightboxMediaType, 'caption': caption, 'poster': poster, 'popup_content': popup_content });
            _self.handleItemClick(element, i);
        });
        _self.setData.push({ 'id': element.dataset.lightboxGroup, 'item': items })
    }

    handleItemClick(element, i) {
        var _self = this;
        const { selector } = _self.options;
        element.addEventListener('click', function (e) {
            
            e.preventDefault();
            _self.getData = [];
            _self.popupMain = '';
            _self.selectorDataset = this.closest(selector).dataset;

            document.body.classList.add('js-lightbox-opened');

            var id = _self.selectorDataset.lightboxGroup;

            // Create the parent div with class 'voyager-lightbox' and 'js-voyager-lightbox'
            const parentDiv = document.createElement('div');
            parentDiv.classList.add('voyager-lightbox', 'js-voyager-lightbox__popup');
            // Create the child div with classes 'voyager-lightbox__container'
            const overlayDiv = document.createElement('div');
            overlayDiv.classList.add('voyager-lightbox__content-overlay');
            // Create the child div with classes 'voyager-lightbox__container'
            const childDiv = document.createElement('div');
            childDiv.classList.add('voyager-lightbox__container');
            if(_self.selectorDataset.story !== undefined) {
                childDiv.classList.add('voyager-story__popup-container');
            }
            // Append the child div to the parent div
            parentDiv.appendChild(overlayDiv);
            parentDiv.appendChild(childDiv);

            _self.getData = _self.setData.find((item) => item.id === id);
            document.body.appendChild(parentDiv);
            _self.popupMain = document.querySelector('.js-voyager-lightbox__popup');
            // _self.story = new Story();
            _self.story = typeof Story !== 'undefined' ? new Story() : null;
            childDiv.innerHTML = _self.popupHtml();
            _self.currentIndex = i;
            _self.splideInit();
            _self.handlePopupClose();
            _self.isOpen = true;
        });
    }

    popupHtml() {
        var _self = this;
        if (!_self.isOpen) {
            var outputHTML = `
                <div class="voyager-lightbox__slider-container">
                    <div class="voyager-lightbox__slider voyager-lightbox__splide splide js-lightbox-items">
                        <div class="voyager-lightbox__splide-track splide__track">
                            <div class="voyager-lightbox__splide-list splide__list">
                                ${_self.getItemsHtml().mainSlideHTML}
                            </div>
                        </div>
                        ${_self.arrowsHtml()}
                    </div>
                    ${_self.closeHtml()}
                    ${_self.thumbnailHtml()}
                </div>`;
            return outputHTML;
        }
    }

    getItemsHtml() {
        var _self = this,
            mainSlideHTML = '',
            thumbnailItemHtml = '';
        _self.currentItems = _self.getData.item;
        _self.currentItems.forEach(function (item) {
            _self.singleItem = [];
            _self.singleItem = item;
            mainSlideHTML += _self.mainSlideHTML();
            thumbnailItemHtml += _self.thumbnailItemHtml()
        });

        return {
            'mainSlideHTML': mainSlideHTML,
            'thumbnailItemHtml': thumbnailItemHtml
        };
    }

    mainSlideHTML() {
        var _self = this;   

        var outputHTML = `
            <div class="voyager-lightbox__slide-content voyager-lightbox__splide-slide splide__slide">
                <div class="voyager-lightbox__slide-media js-lightbox-media">
                    ${_self.addMedia().mediaHTML}
                </div>`
        if(_self.addMedia().caption) {
            outputHTML += `<div class="voyager-lightbox__slide-description-wrap">
                <div class="voyager-lightbox__slide-description-inner">
                    <h4 class="voyager-lightbox__slide-title js-lightbox-caption">${_self.addMedia().caption}</h4>
                    <div class="voyager-lightbox__slide-description"></div>
                </div>
            </div>`;
        }
        outputHTML += `</div>`;
        return outputHTML;
    }

    thumbnailItemHtml() {
        var _self = this,
            item = _self.singleItem,
            outputHTML = `
                <div class="voyager-lightbox__thumbnail-item splide__slide">`;
        if (item.type === 'image') {
            outputHTML += `<img src="${item.link}" alt="" class="voyager-lightbox__thumbnail-image" />`
        }

        if (item.type === 'video') {
            outputHTML += `<img src="${item.poster}" alt="" class="voyager-lightbox__thumbnail-image" />`
        }

        outputHTML += `</div>`;

        return outputHTML;
    }

    addMedia() {
        var _self = this,
            item = _self.singleItem;
        if (item) {
            var mediaHTML = '';
            if (item.type === 'image') {
                mediaHTML = '<img src="' + item.link + '" alt="Lightbox Image" class="voyager-lightbox__slide-image">';
            }

            if (item.type === 'video') {
                mediaHTML = `
                    <video class="voyager-lightbox__video voyager-lightbox__slide-video video-js" controls muted preload="auto">
                        <source src="${item.link}">
                    </video>`
            }

            if(item.type === 'story') {
                const popup_content = item.popup_content;
                const content = JSON.parse(popup_content);
                mediaHTML = _self.story.outputHTML(content);
            }

            return {
                'mediaHTML': mediaHTML,
                'caption': item.caption
            };
        }
    }

    closeHtml() {
        var _self = this,
            outputHTML = '';
        const { icons } = _self.options;
        var close = icons.close;
        outputHTML += `
            <div class="voyager-lightbox__controls">
                <button class="voyager-lightbox__button-close voyager-lightbox__button js-lightbox-close" tabindex="2" aria-label="Close">${close}</button>
            </div>`;

        return outputHTML;
    }

    arrowsHtml() {
        var _self = this,
            outputHTML = `
            <div class="voyager-lightbox__control-bar splide__control-bar voyager-control-bar">
                <div class="splide__arrows splide__arrows-wrapper voyager-lightbox__arrows-wrapper">
                    <button class="splide__arrow splide__arrow--prev splide__arrows-button voyager-lightbox__arrows-button splide__arrows-button--prev voyager-lightbox__arrows-button--prev">
                        <i class="splide__arrows-icon voyager-lightbox__arrows-icon splide__arrows-icon--prev voyager-lightbox__arrows-icon--prev voyager-icon-arrow-pointing-left-big voyager-icon"></i>
                    </button>
                    <button class="splide__arrow splide__arrow--next splide__arrows-button voyager-lightbox__arrows-button splide__arrows-button--next voyager-lightbox__arrows-button--next">
                        <i class="splide__arrows-icon voyager-lightbox__arrows-icon splide__arrows-icon--next voyager-lightbox__arrows-icon--next voyager-icon-arrow-pointing-right-big voyager-icon"></i>
                    </button>
                </div>
            </div>
        `;

        return outputHTML;
    }

    thumbnailHtml() {
        var _self = this,
            outputHTML = '';

        if (_self.selectorDataset.lightboxVariation !== undefined) {
            _self.popupMain.classList.add('voyager-lightbox--thumbnail');
            outputHTML = `
                <div class="voyager-lightbox__thumbnail-slider splide js-lightbox-thumbnail">
                    <div class="voyager-lightbox__thumbnail-track splide__track">
                        <div class="voyager-lightbox__thumbnail-items splide__list">
                            ${_self.getItemsHtml().thumbnailItemHtml}
                        </div>
                    </div>
                </div>`;
        }

        return outputHTML;
    }

    splideInit() {
        var _self = this;

        _self.mainSplide = new Splide('.js-lightbox-items', {
            rewind: true,
            pagination: false,
            arrows: true
        });

        if (_self.popupMain.querySelector('.js-lightbox-thumbnail') !== null) {
            var thumbnails = new Splide('.js-lightbox-thumbnail', {
                fixedWidth: 200,
                fixedHeight: 120,
                gap: 10,
                rewind: true,
                pagination: false,
                isNavigation: true,
                arrows: false,
                breakpoints: {
                    600: {
                        fixedWidth: 120,
                        fixedHeight: 100,
                    },
                },
            });

            _self.mainSplide.sync(thumbnails);
            thumbnails.mount();
        }

        _self.mainSplide.mount();

        _self.mainSplide.go(_self.currentIndex);
        if(_self.story) {
            _self.story.splideInit(_self.currentIndex, _self.mainSplide);
        }


        const videos = _self.popupMain.querySelectorAll('video');
        videos.forEach((item) => {
            videojs(item);
        });

        _self.mainSplide.on('moved', function (newIndex, oldIndex) {
            _self.currentIndex = newIndex;
            var prevSlideVideo = _self.mainSplide.Components.Elements.slides[oldIndex].querySelector('video');
            if (prevSlideVideo) {
                prevSlideVideo.pause();
            }

            _self.videoInit(newIndex);
            if(_self.story) {
                _self.story.splideInit(newIndex, _self.mainSplide);
            }
            
        });

        _self.videoInit(_self.currentIndex);
    }

    handlePopupClose() {
        var _self = this;

        _self.popupMain.querySelector('.js-lightbox-close').addEventListener('click', function () {
            _self.popupMain.remove();
            _self.isOpen = false;

            document.body.classList.remove('js-lightbox-opened');
        })
    }

    videoInit(currentIndex) {
        var _self = this,
            item = _self.mainSplide.Components.Elements.slides[currentIndex].querySelector('video');

        if (item !== null) {
            var video = videojs(item);
            video.play();
        }
    }

    init() {
        this.groupElement();
    }
}

const voyagerLightbox = new VoyagerLightbox();
voyagerLightbox.init()

